import CardPointeDataModel from "@/common/models/CardPointeDataModel";
import axios from "axios";

export default class apiCardPointe {

    static async init(username: string, password: string, headless: boolean): Promise<CardPointeDataModel> {
        let response = await axios.post("http://localhost:5667/CardPointe/Init", {
            username: username,
            password: password,
            headless: headless
        });        
        let model = CardPointeDataModel.from(response.data)
        return model;
    }
    
    static async securityCode(securityCode: string): Promise<void> {
        let response = await axios.post("http://localhost:5667/CardPointe/SecurityCode", {
            securityCode: securityCode         
        });                
    }

    static async close(): Promise<void> {
        try {
            let response = await axios.post("http://localhost:5667/CardPointe/Close");                
        }
        catch {
            console.log("..")
        }
    }

    static async getDataByMid(merchantId: string, dateStart: string, dateEnd: string): Promise<CardPointeDataModel> {
        let response = await axios.post("http://localhost:5667/CardPointe/GetDataByMid", {        
            merchantId: merchantId,
            dateStart: dateStart,
            dateEnd: dateEnd,
        });        
        let model = CardPointeDataModel.from(response.data)
        return model;
    }
        
    
}
